export enum EventsTypes {
  LifestylePrograms = "Lifestyle Programs",
  Notice = "Notice",
  PremiumServices = "Premium Services",
  ConciergeRequest = "conciergeRequest",
  FamilyVisit = "familyVisit",
  Medical = "medical",
  Concierge = "concierge",
  ScheduledCall = 'scheduledCall',
  RealtimeCall = 'realtimeCall',
  Meal = 'Meal'
}